<template>
    <div class="types-create-modal">
        <ModalContainer :title="$t('types.add_type')" identifier="types-create-modal" :closable="true">
            <Form class="form" @submit="save" :disabled="is_saving">
                <FormInputText v-model="$v.type.name.$model" ref="name" identifier="name" :label="$t('types.name')"
                               :disabled="is_saving" :has-error="$v.type.name.$error">
                    <template v-slot:errors>
                        <p v-if="!$v.type.name.required">
                            {{$t('validation.x_is_required',{x: $t('types.name')})}}
                        </p>
                    </template>
                </FormInputText>

                <Button type="submit" className="--primary --small" :class="{spinner: is_saving}">
                    {{$t('save')}}
                </Button>
            </Form>
        </ModalContainer>
    </div>
</template>

<script>
    import ModalContainer from "../modal/ModalContainer";
    import Form from "../form/Form";
    import FormInputText from "../form/FormInputText";
    import FormGroupTwo from "../form/FormGroupTwo";
    import FormInputSelect from "../form/FormInputSelect";
    import {required, email} from 'vuelidate/lib/validators'
    import Button from "../Button";
    import FormInputPassword from "@/components/form/FormInputPassword";

    export default {
        name: "TypesCreateModal",
        components: {FormInputPassword, Button, FormInputSelect, FormGroupTwo, FormInputText, Form, ModalContainer},
        data() {
            return {
                type: {
                    name: null,
                },
                is_saving: false,
            }
        },
        validations: {
            type: {
                name: {required},
            }
        },
        methods: {
            close(status) {
                this.$modal.hide('types-create-modal', status);
            },
            save() {
                this.$v.type.$touch();
                if (this.$v.type.$anyError || this.is_saving)
                    return;

                this.is_saving = true;

                const payload = {
                    name: this.type.name,
                }

                this.$axios.post(`types`, payload).then(({data}) => {
                    this.$notify({
                        text: this.$t('types.success_created'),
                        type: 'success',
                    });

                    this.is_saving = false;
                    this.close(true);
                }).catch(e => {
                    this.is_saving = false;

                    this.$notify({
                        title: this.$t('error'),
                        text: this.$larerror(e.response.data.errors, this.$t('types.error_create')),
                        type: 'error',
                    });
                });
            },
        },
        mounted() {
            this.$refs.name.$el.children[1].focus();
        }
    }
</script>
